"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const annotation_serializer_1 = require("../serializers/annotation.serializer");
class AnnotationClient {
    static newInstance(options, retryOptions) {
        return new AnnotationClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new annotation_serializer_1.AnnotationSerializer());
    }
    constructor(client, serializer) {
        this.client = client;
        this.serializer = serializer;
    }
    async save(annotations, parentId, parentType, headers) {
        const response = await this.client.post(`/annotations`, {
            annotations,
        }, {
            headers,
            params: {
                parentId,
                parentType,
            }
        });
        return this.serializer.serialize(response.body);
    }
    async findOne(id, headers) {
        const response = await this.client.get(`/annotations/${id}`, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async findById(annotationId, headers) {
        const response = await this.client.get(`/annotations.findById`, {
            headers,
            params: {
                annotationId,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async findByAnnotableDocument(documentId, parentId, parentType, headers) {
        const response = await this.client.get(`/annotations.findByAnnotableDocument`, {
            headers,
            params: {
                documentId,
                parentId,
                parentType,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async findByDocumentAndAuthor(authorId, documentId, headers) {
        const response = await this.client.get(`/annotations.findByDocumentAndAuthor`, {
            headers,
            params: {
                authorId,
                documentId,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async deleteByAnnotableDocument(annotableDocumentId, headers) {
        await this.client.delete(`/annotations.deleteByAnnotableDocument`, {
            headers,
            params: {
                documentId: annotableDocumentId,
            },
        });
    }
    async deleteAnnotationsByDocument(annotableDocumentId, annotationIds, headers) {
        await this.client.delete(`/annotations`, {
            headers,
            params: {
                documentId: annotableDocumentId,
                annotationIds: annotationIds,
            },
        });
    }
}
exports.AnnotationClient = AnnotationClient;
//# sourceMappingURL=annotation.client.js.map